import { createTheme } from "@mui/material/styles";

const theme = createTheme({
  palette: {
    mode: "light",
    background: {
      default: "#f9fafb",
      paper: "#ffffff"
    },
    text: {
      primary: "#0d2633",
      secondary: "#627884"
    },
    primary: {
      main: "#27a599",
      contrastText: "#ffffff"
    },
    secondary: {
      main: "#e4f3ee",
      contrastText: "#1f7f72"
    },
    success: {
      main: "#39ac82"
    },
    info: {
      main: "#3390cc"
    },
    divider: "hsla(200, 20%, 90%, 1)"
  },
  typography: {
    fontFamily: "'Inter', system-ui, -apple-system, Segoe UI, Roboto, Arial, sans-serif",
    h1: { fontWeight: 700, letterSpacing: "-0.02em" },
    h2: { fontWeight: 700, letterSpacing: "-0.02em" },
    h3: { fontWeight: 700, letterSpacing: "-0.01em" },
    h4: { fontWeight: 700, letterSpacing: "-0.01em" },
    h5: { fontWeight: 700 },
    h6: { fontWeight: 700 }
  },
  shape: { borderRadius: 16 }
});

export default theme;
